"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelection = void 0;
const lodash_1 = require("lodash");
const react_1 = require("react");
const useSelection = (initialSelection = []) => {
    const [selection, setSelection] = (0, react_1.useState)(initialSelection);
    const select = (0, react_1.useCallback)((item) => {
        setSelection((_) => {
            if (selection.includes(item))
                return selection;
            return [...selection, item];
        });
    }, [selection, setSelection]);
    const toggleSelection = (0, react_1.useCallback)((item) => {
        setSelection((_) => {
            console.log("setSelection", _);
            if (selection.includes(item)) {
                return (0, lodash_1.without)(selection, item);
            }
            else {
                console.log("add");
                return [...selection, item];
            }
        });
    }, [selection, setSelection]);
    const resetSelection = (0, react_1.useCallback)((selection = []) => {
        setSelection(selection);
    }, []);
    const isSelected = (0, react_1.useCallback)((item) => selection.includes(item), [
        selection,
    ]);
    return { selection, resetSelection, select, toggleSelection, isSelected };
};
exports.useSelection = useSelection;
//# sourceMappingURL=useSelection.js.map